// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1R3Za","actionsCol":"EnrolledClinics_actionsCol__2pLZB"};